import axios from "axios";

export default async function editForm(projectName, formName,  data){
    return await axios.patch(`/project/${projectName}/${formName}/edit-form`, {...data});
}